import ET3Div from "../et3-div";
import Et3Text from "../et3-text";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const TagBadge = withLiteObserverAndTheme<{
  tag: string;
  tagColor: string;
  tagWidth: number;
  isPaid: boolean;
}>((props) => {
  const { tag, isPaid, tagColor, tagWidth, theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={tagWidth}
      height={36}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={tagColor}
      style={{
        borderRadius: 5,
        border: `1px solid ${colors.all.darkGray}`,
        opacity: isPaid ? 1 : 0
      }}
      onClick={() => {}}
    >
      <Et3Text
        text={tag}
        fontFamily="BOLD"
        fontSize={10}
        color={colors.all.white}
        isSpan={true}
        style={{}}
      />
    </ET3Div>
  );
});

export default TagBadge;
